import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';
//service
import SectionService from '@/core/services/section.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    LoaderComponent
  }
})
export default class EditSectionComponent extends Vue {

  sectionService: any = new SectionService();
  sidebarService: any = new SidebarService();
  surveyList: any = [];
  genericErr: any = [];
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  modal: boolean = false;
  error: boolean = false;
  title: string = "";
  survey: string = "";

  mounted (){
    const _ = this;
    _.getById();
    _.getSurveys();
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  getSurveys(){
    const _ = this;
    _.isLoading = true;
    _.sectionService.getSurveys().then((data: any) => {
      _.surveyList = data['data'].surveys;
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
    .catch((err: any) => {
      if(err.response.data.message.includes('Invalid or inexistent user')){
        localStorage.removeItem('tk_auth');
        _.logInModal = true;
        console.log(_.logInModal, '_.logInModal')
      }
      _.isLoading = false;
    })
  }

  edit(){
    const _ = this;
    let section = {
      title: _.title
    };
    let idSection: any = location.href.split("/");
    idSection = idSection[5];
    _.isLoading = true;
    _.sectionService.edit(section, idSection).then((data: any) => {
      _.isSuccess = true;
      _.isErrorServer = false;
      _.error = false;
      _.modal = true;
      setTimeout(() => {
        _.isLoading = false;
        _.$router.push('/section');
      }, 1500)
    })
    .catch((err: any) => {
      _.modal = true;
      _.error = true;
      _.isErrorServer = true;
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }

  getById(){
    const _ = this;
    let idSection: any = location.href.split("/");
    idSection = idSection[5];
    _.isLoading = true;
    _.sectionService.getById(idSection).then((data: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
      _.title = data["data"].section.title;
    })
    .catch((err: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }

  validations(title = ''){
    const _ = this;
    _.genericErr = [];
    if(title == ''){
      _.genericErr.push("Por favor escribe un nombre");
    }
    if(_.genericErr.length > 0){
      _.modal = true;
      _.error = true;
      return;
    }
    _.edit()
  }
}
